<nav class="navbar navbar-expand-lg bg-body-tertiary m-0 p-0 shadow-sm">
    <div class="container-fluid">
        <a class="navbar-brand m-0 p-0" href="#">
            <img class="nav-logo" ngSrc="/assets/logo_color_header.png" alt="VineMeds" height="43" width="150" priority>
            <span class="badge bg-dark d-print-none">ADMIN</span>
        </a>

        <button class="navbar-toggler shadow-sm d-print-none" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div [ngbCollapse]="isMenuCollapsed" id="navbarNav" class="collapse navbar-collapse justify-content-between d-print-none" style="margin-left: 2rem;">
            <ul class="navbar-nav" cdkMenuBar [ngClass]="{'nav-tabs': this.isMenuCollapsed}">
                <li class="nav-item" role="none">
                    <button cdkMenuItem class="nav-link" type="button" [class.active]="isActive('/dashboard')" routerLink="/dashboard" (click)="isMenuCollapsed = true">
                        <i class="bi bi-house-door me-2"></i> Dashboard
                    </button>
                </li>

                @for (section of sections(); track section.label) {
                    <li class="nav-item" role="none">
                        <button cdkMenuItem class="nav-link dropdown-toggle" type="button" [class.active]="isSectionActive(section)" [cdkMenuTriggerFor]="sectionMenu">
                            <i class="bi me-2" [ngClass]="section.icon"></i> {{ section.label }}
                        </button>

                        <ng-template #sectionMenu>
                            <div cdkMenu class="dropdown-menu show position-static">
                                @for (item of section.items; track $index) {
                                    <button cdkMenuItem class="dropdown-item" [class.divider-before]="item.dividerBefore" type="button" [routerLink]="item.link" [queryParams]="item.queryParams" (click)="isMenuCollapsed = true">
                                        @if (item.icon) { <i class="bi me-2" [ngClass]="item.icon"></i> }
                                        {{ item.label }}
                                    </button>
                                }
                            </div>
                        </ng-template>
                    </li>
                }
            </ul>

            <button class="nav-link vm-logout" (click)="onLogout()">
                <i class="bi bi-box-arrow-right me-2 dropdown-menu-icon"></i> Logout
            </button>
        </div>
    </div>
</nav>
